<template>
  <a :href="finalUrl" class="link-item" :class="{ 'en-font': lang === 'ENG' }">
    <div class="card-top">
      <div class="main-icon" alt="icon" v-html="image"></div>
      <img
        src="/static_img/skinc/appendix/arrow_normal.svg"
        class="arrow-icon arrow-normal"
        alt="arrow"
      />
      <img
        src="/static_img/skinc/appendix/arrow_focus.svg"
        class="arrow-icon arrow-focus"
        alt="arrow"
      />
    </div>
    <div class="skinc-card-body">
      <h4 class="link-title">{{ text }}</h4>
      <p class="link-description">{{ description }}</p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'AppendixLinkItem',
  props: {
    text: String,
    url: String,
    image: String,
    description: String,
    lang: { type: String, default: 'KOR' }
  },
  computed: {
    finalUrl() {
      if (this.lang === 'ENG' && this.url) {
        try {
          const urlObject = new URL(this.url, window.location.origin);
          urlObject.searchParams.set('l', 'ENG');
          return urlObject.protocol === window.location.protocol
            ? `${urlObject.pathname}${urlObject.search}${urlObject.hash}`
            : urlObject.href;
        } catch (error) {
          console.error('Invalid URL provided:', this.url);
          return this.url;
        }
      }
      return this.url;
    }
  }
};
</script>

<style scoped>
.link-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  border-radius: 8px;
  text-decoration: none;
  color: #000;
  height: 100%;
  box-sizing: border-box;
  background-color: #f8f4f0;
  transition: background-color 0.2s, border 0.2s, padding 0.2s;
}

.link-item:hover {
  background-color: #ee7501;
  color: white;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2rem;
}

.main-icon {
  color: #ee7501;
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.link-item:hover .main-icon {
  color: white;
}

.arrow-icon {
  width: 28px;
  height: 28px;
}

.arrow-focus {
  display: none;
}
.arrow-normal {
  display: block;
}
.link-item:hover .arrow-focus {
  display: block;
}
.link-item:hover .arrow-normal {
  display: none;
}

.skinc-card-body {
  margin-bottom: auto;
  padding: 20px 0px;
}

.link-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
  text-align: left;
}

.link-description {
  font-size: 20px;
  color: #666;
  line-height: 1.5;
  margin: 0;
  text-align: left;
}

.link-item:hover .link-description {
  color: white;
}

.link-item.en-font .link-title {
  font-size: 22.4px;
}

.link-item.en-font .link-description {
  font-size: 16px;
}

@media (max-width: 576px) {
  .link-description {
    display: none;
  }

  .skinc-card-body {
    padding: 0;
  }
}
</style>
